import { useContext } from 'react';
import { TenantContext } from '../contexts/TenantContext';
import type { TenantContextProps } from '../contexts/TenantContext';

/**
 * Custom hook to consume active school tenant branding and settings
 */
export const useTenant = (): TenantContextProps => {
  return useContext(TenantContext);
};

export default useTenant;
